import { RatingRubricContent } from "./RatingRubricContent";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { JobInternalConfig as JobInternalConfigType } from "@/types";

export const ExpandedRubricModal = ({
  jobInternalConfig,
  onClose,
  onEditClick,
  onRegenerateClick,
}: {
  jobInternalConfig: JobInternalConfigType;
  onClose: () => void;
  onEditClick: () => void;
  onRegenerateClick: () => void;
}) => {
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent
        className="max-h-[90vh] max-w-7xl overflow-y-auto p-8"
        // Prevent the dialog from focusing on the first button, showing its tooltip, upon opening
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="sr-only">
          <DialogTitle>Rating Rubric</DialogTitle>
        </DialogHeader>
        <RatingRubricContent
          jobInternalConfig={jobInternalConfig}
          onEditClick={onEditClick}
          onRegenerateClick={onRegenerateClick}
        />
      </DialogContent>
    </Dialog>
  );
};
